module.exports = __webpack_public_path__ + "img/img4.cea665f4.jpg";